import { render, staticRenderFns } from "./SorteoNumerosSacados.vue?vue&type=template&id=249d7032&scoped=true&"
import script from "./SorteoNumerosSacados.vue?vue&type=script&lang=ts&"
export * from "./SorteoNumerosSacados.vue?vue&type=script&lang=ts&"
import style0 from "./SorteoNumerosSacados.vue?vue&type=style&index=0&id=249d7032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249d7032",
  null
  
)

export default component.exports